
























import { defineComponent } from '@nuxtjs/composition-api';

export type DemoPage = Blok & {
  sections: Blok[];
};

export default defineComponent({
  props: {
    blok: { type: Object as () => DemoPage, required: true },
  },
});
